import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledHeaderContainer = styled(Flex)`
    width: 100%;
    position: relative;
`;

export const StyledHeaderDescription = styled.p`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["400"])};
    margin: 0;
`;

export const StyledHeaderTitle = styled.h1`
    ${mixins.setFontVariant("h2", colorsPalettes.carbon["400"])};
    margin: 0;
`;
